module.exports = "<ht-contact-list (addAction)=\"onAdd($event)\" (editAction)=\"onEdit($event)\" (deleteAction)=\"onDelete($event)\"></ht-contact-list>"